/* @flow weak */
import app from '../app/reducer'
import config from '../config/reducer'
import intl from '../intl/reducer'
import { combineReducers } from 'redux'
import { fieldsReducer as fields } from '../lib/redux-fields'
import { updateStateOnStorageLoad } from './storage'

const configureReducer = () => {
  let reducer = combineReducers({
    app,
    config,
    fields,
    intl,
  })

  reducer = updateStateOnStorageLoad(reducer)

  return reducer
}

export default configureReducer



// WEBPACK FOOTER //
// ./src/common/configure/reducer.js